import React from "react";
import useText from "constants/text";
import { EmptyIllustration } from "illustrations";
import styled from "styled-components";
import { createStyles, makeStyles } from "@material-ui/styles";

export const Title = styled("h3")<{ color?: string }>`
  padding: 1rem 1rem;
  border-radius: 4px;
  text-align: center;
  width: 100%;
  margin: 0 auto;
  font-size: 1rem;
  font-weight: 200;
  color: ${(p) => p.color || "#959595"};

  .highlighted {
    font-weight: 600;
    color: initial;
  }
`;
const useStyles = makeStyles(() =>
  createStyles({
    divStyled: {
      display: "none",
      flexDirection: "column",
      alignItems: "center",
      marginTop: "7rem",
    },
  })
);

export const EmptyTableContent = () => {
  const { text } = useText();
  const styles = useStyles();
  return (
    <div className={styles.divStyled}>
      <EmptyIllustration />
      <Title> {text.all.empty_table} </Title>
    </div>
  );
};
